module.exports = __webpack_public_path__ + "img/tech_image_10_3.3f88fef6.jpg";